import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import BlobLayout from "@/components/layout/BlobLayout"

export const Route = createFileRoute("/not-found")({
  component: NotFound,
})

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <BlobLayout>
      <img src="/404/404_image.png" alt="404" />
      <h1 className="z-10 font-mukta text-xl font-bold lg:text-6xl">
        Page Not Found
      </h1>
      <p className="z-10 max-w-lg text-center font-mukta text-lg font-thin text-gray-400">
        Sorry the page you were looking for was not found. If you think there's
        something wrong, please report it
      </p>
      <div className="flex flex-row gap-2">
        <Button onClick={() => navigate({ to: "/" })}>Go home</Button>
        <Button
          variant="outline"
          className="text-[#179195] ring-2 ring-[#179195]"
          onClick={() => navigate({ to: "/contact-us" })}
        >
          Contact Us
        </Button>
      </div>
    </BlobLayout>
  )
}
